import ResignCertificates from "../../../../components/company/workforce/resigned/ResignCertificates";

export default function RelievingLetterPage(){
    return <ResignCertificates title="Relieving Letter"/>
}